import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { promptsAPI } from '../services/api';
import './PromptsList.css';

const PromptsList = () => {
  const [prompts, setPrompts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const { logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    loadPrompts();
  }, []);

  const loadPrompts = async () => {
    try {
      setLoading(true);
      setError('');
      const result = await promptsAPI.list(100, 0);
      setPrompts(result.prompts);
    } catch (err) {
      setError(err.response?.data?.detail || 'Failed to load prompts');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (promptName, e) => {
    e.stopPropagation();
    if (window.confirm(`Are you sure you want to delete "${promptName}"?`)) {
      try {
        await promptsAPI.delete(promptName);
        await loadPrompts();
      } catch (err) {
        setError(err.response?.data?.detail || 'Failed to delete prompt');
      }
    }
  };

  const filteredPrompts = prompts.filter((prompt) =>
    prompt.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    prompt.content.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="prompts-container">
      <header className="prompts-header">
        <h1>Prompt Management</h1>
        <div className="header-actions">
          <button onClick={() => navigate('/prompts/new')} className="btn btn-primary">
            + New Prompt
          </button>
          <button onClick={logout} className="btn btn-secondary">
            Logout
          </button>
        </div>
      </header>

      <div className="prompts-content">
        <div className="search-bar">
          <input
            type="text"
            placeholder="Search prompts by name or content..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
        </div>

        {error && <div className="error-banner">{error}</div>}

        {loading ? (
          <div className="loading">Loading prompts...</div>
        ) : filteredPrompts.length === 0 ? (
          <div className="empty-state">
            {searchTerm ? 'No prompts match your search.' : 'No prompts found. Create your first prompt!'}
          </div>
        ) : (
          <div className="prompts-grid">
            {filteredPrompts.map((prompt) => (
              <div
                key={prompt.id}
                className="prompt-card"
                onClick={() => navigate(`/prompts/edit/${encodeURIComponent(prompt.name)}`)}
              >
                <div className="prompt-card-header">
                  <h3 className="prompt-name">{prompt.name}</h3>
                  <button
                    onClick={(e) => handleDelete(prompt.name, e)}
                    className="delete-btn"
                    title="Delete prompt"
                  >
                    ×
                  </button>
                </div>
                <div className="prompt-content-preview">
                  {prompt.content.length > 200
                    ? `${prompt.content.substring(0, 200)}...`
                    : prompt.content}
                </div>
                <div className="prompt-id">ID: {prompt.id}</div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default PromptsList;
